var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pvcWbWrapper" }, [
    _c("div", {
      ref: "whiteboardWrapper",
      staticClass: "pvc-whiteboard-rapper",
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/whiteboard/PanoWhiteboard.vue?vue&type=template&id=7406134f&scoped=true&
// module id = null
// module chunks = 